import React from 'react';
import { Link } from 'react-router-dom';
import { FiMonitor, FiBriefcase, FiActivity, FiLayers, FiCode, FiPenTool } from 'react-icons/fi';

const programs = [
    { icon: <FiMonitor />, name: "B.Tech", count: "2,500+", duration: "4 Years", link: "/c_pages/B.Tech" },
    { icon: <FiBriefcase />, name: "MBA", count: "1,800+", duration: "2 Years", link: "/c_pages/MBA" },
    { icon: <FiActivity />, name: "MBBS", count: "600+", duration: "5.5 Years", link: "/c_pages/MBBS" },
    { icon: <FiLayers />, name: "M.Tech", count: "1,200+", duration: "2 Years", link: "/c_pages/M.Tech" },
    { icon: <FiCode />, name: "BCA", count: "900+", duration: "3 Years", link: "/c_pages/BCA" },
    { icon: <FiPenTool />, name: "Design", count: "500+", duration: "4 Years", link: "/c_pages/Design" },
];

const TopProgramsSection = () => {
    return (
        <section className="py-20 bg-white">
            <div className="container mx-auto px-4 text-center">

                <div className="inline-block px-4 py-1 rounded-full border border-orange-200 text-brand-orange text-xs font-bold uppercase tracking-widest mb-4">
                    Discover Your Path
                </div>

                <h2 className="text-4xl font-bold text-gray-800 mb-2">
                    Explore <span className="text-brand-orange">Top Programs</span>
                </h2>

                <div className="w-24 h-1 bg-brand-orange mx-auto mt-4 rounded-full mb-12"></div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {programs.map((prog, index) => (
                        <Link
                            key={index}
                            to={prog.link}
                            className="group relative rounded-3xl p-8 text-left transition-all duration-300 border border-gray-100 overflow-hidden bg-white hover:border-brand-orange hover:shadow-xl hover:-translate-y-2"
                        >
                            {/* Hover Corner Accent */}
                            <div className="absolute top-0 right-0 w-32 h-32 bg-orange-50 rounded-bl-[100px] opacity-0 group-hover:opacity-100 transition-all duration-500"></div>

                            <div className="flex items-start justify-between relative z-10">
                                <div className="p-4 rounded-2xl text-2xl mb-4 bg-orange-50 text-brand-orange group-hover:bg-brand-orange group-hover:text-white transition-all duration-300">
                                    {prog.icon}
                                </div>
                            </div>

                            <h3 className="text-2xl font-bold mb-1 relative z-10 text-gray-800 transition">
                                {prog.name}
                            </h3>
                            <p className="text-sm mb-6 relative z-10 text-gray-500 transition">
                                {prog.count} Colleges
                            </p>

                            <div className="inline-block px-3 py-1 rounded-md text-xs font-bold relative z-10 bg-orange-50 text-orange-600 group-hover:bg-orange-100 transition">
                                {prog.duration}
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TopProgramsSection;
